import { FormBuilder, Validators } from '@angular/forms';
import { Gender } from '@bca-shared/models/_enums';
import { FormUtils } from '@bca-shared/shared.utils';
import { CountryCode, ProductStart } from '@bca-user-data/models/_enums';
import { ICountrySettings } from '@bca-user-data/models/country';
import { DateValidator } from '@bca-shared/validators/valid-date.validator';
import { AgeValidator } from '@bca-shared/validators/minimal-age.validator';

const requiredValidator = Validators.required;

export const createUserDataForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    id: null,
    gender: [Gender.MALE as Gender, requiredValidator],
    image: null,
    initials: [null, [requiredValidator, Validators.maxLength(10)]],
    middleName: null,
    lastName: [null, requiredValidator],
    email: [null, [requiredValidator, Validators.pattern(FormUtils.Patterns.EMAIL)]],
    country: createCountryForm(formBuilder),
    address: createAddressForm(formBuilder),
    useProduct: createUseProductForm(formBuilder),
    birthDate: [null, [requiredValidator, DateValidator.dateValidator, AgeValidator.ageValidator]]
  });
};

export const createUseProductForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    type: [ProductStart.DIRECTLY as ProductStart, requiredValidator],
    date: null
  });
};

export const createCountryForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    value: ['NL', requiredValidator],
    label: ['Nederland', requiredValidator]
  });
};

export const createAddressForm = (formBuilder: FormBuilder) => {
  return formBuilder.group({
    postcode: [null, requiredValidator],
    houseNumber: [null, requiredValidator],
    addition: [null],
    street: [null, requiredValidator],
    city: [null, requiredValidator]
  });
};

export const getCountrySettings = (value: CountryCode): ICountrySettings => {
  switch (value) {
    case CountryCode.NL: {
      return {
        postcodeLength: 7,
        searchableAddress: true
      };
    }
    case CountryCode.BE: {
      return {
        postcodeLength: 4,
        searchableAddress: false
      };
    }
    case CountryCode.DK: {
      return {
        postcodeLength: 4,
        searchableAddress: false
      };
    }
    case CountryCode.FR: {
      return {
        postcodeLength: 5,
        searchableAddress: false
      };
    }
    case CountryCode.DE: {
      return {
        postcodeLength: 5,
        searchableAddress: false
      };
    }
    case CountryCode.GR: {
      return {
        postcodeLength: 6,
        searchableAddress: false
      };
    }
    case CountryCode.IT: {
      return {
        postcodeLength: 5,
        searchableAddress: false
      };
    }
    case CountryCode.LU: {
      return {
        postcodeLength: 4,
        searchableAddress: false
      };
    }
    case CountryCode.ES: {
      return {
        postcodeLength: 5,
        searchableAddress: false
      };
    }
    case CountryCode.SE: {
      return {
        postcodeLength: 6,
        searchableAddress: false
      };
    }
    case CountryCode.CH: {
      return {
        postcodeLength: 4,
        searchableAddress: false
      };
    }
    case CountryCode.GB: {
      return {
        postcodeLength: 8,
        searchableAddress: false
      };
    }
    case CountryCode.US: {
      return {
        postcodeLength: 10,
        searchableAddress: false
      };
    }
    default: {
      return {
        postcodeLength: 6,
        searchableAddress: false
      };
    }
  }
};
